// extracted by mini-css-extract-plugin
module.exports = {"attr2":"AttributeCreateModal_attr2__wvGaZ","list":"AttributeCreateModal_list__1n-N2","row":"AttributeCreateModal_row__28qyS"};